import { t } from 'i18next';
import { Control, FieldErrors, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { CellProps } from 'react-table';

import { Button, Field } from 'coreOld/components';
import { CellText, FileList } from 'coreOld/elements';
import { AlignText, ButtonType, InputType } from 'coreOld/enums';
import { IJob } from 'jobsOld/types';
import { IRequestJobs } from 'support/types';

export const columns = (
  control: Control<IRequestJobs>,
  getValues: UseFormGetValues<IRequestJobs>,
  setValue: UseFormSetValue<IRequestJobs>,
  errors: FieldErrors<IRequestJobs>,
  openUploadModal?: (job: IJob) => void
) => [
  {
    Header: () => <CellText mainText={t('labelDiscipline')} subTexts={[t('labelJobName')]} />,
    accessor: 'disciplineName',
    width: '30%',
    Cell: ({ row }: CellProps<any, JSX.Element>) => (
      <>
        <CellText mainText={row.original.disciplineName} marginBottom={10} />
        <Field
          type={InputType.TEXTFIELD}
          inputProps={{
            name: `jobs.${row.index}.name`,
            control,
            placeholder: t('labelJobName'),
            value: row.original.name,
            error: errors?.jobs?.[row.index]?.name,
            showFieldError: true,
          }}
        />
      </>
    ),
  },
  {
    Header: () => (
      <CellText alignText={AlignText.LEFT} mainText={t('labelSupportRequestJobDescription')} />
    ),
    accessor: 'details',
    width: '50%',
    Cell: ({ row }: CellProps<any, JSX.Element>) => (
      <Field
        type={InputType.TEXTEDITOR}
        inputProps={{
          name: `jobs.${row.index}.details`,
          control,
          getValues,
          setValue,
          placeholder: t('labelJobDescription'),
          value: row.original.description,
          error: errors?.jobs?.[row.index]?.details,
          showFieldError: true,
        }}
      />
    ),
  },
  {
    accessor: 'attachments',
    width: '20%',
    Cell: ({ row }: CellProps<any, JSX.Element>) => (
      <>
        <FileList files={row.original.attachments} marginBottom={10} />

        <Button onClick={() => openUploadModal(row.original)} btnType={ButtonType.INLINE}>
          Upload
        </Button>
      </>
    ),
  },
];
